import React from "react";
import styles from "./Heading.module.css";
export const Heading = ({ children }) => (
  <h2 className={styles.heading}>{children}</h2>
);
